export function isChatWorkspacePath(pathname) {
  const path = String(pathname || "");
  return (
    path.startsWith("/menu/chats") ||
    path === "/assistant/core" ||
    path.startsWith("/assistant/core/")
  );
}

export function isChatInputPath(pathname) {
  const path = String(pathname || "").replace(/\/+$/, "");

  if (path === "/assistant/core") return true;

  return (
    /^\/menu\/chats\/event\/[^/]+$/.test(path) ||
    /^\/menu\/chats\/direct\/[^/]+\/[^/]+$/.test(path) ||
    /^\/menu\/chats\/group\/[^/]+$/.test(path) ||
    /^\/menu\/chats\/support\/[^/]+$/.test(path)
  );
}
